export default __webpack_public_path__ + "static/media/maybank.6c182951.jpg";